import {
  AbstractAuthorizationSelectionForm,
  ChangedItem
} from '@/app/platform/platform-management/user-group-block/containers/user-group-linked-app-authorizations-editor/abstract-authorization-selection-form';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { PageFeature } from '@ervo/page-framework';

export class FeatureAuthorizationSelectionForm extends AbstractAuthorizationSelectionForm<NavigationItemFeatureChange> {
  init(egiApp: EgiAppEntity, userGroup: UserGroupEntity) {
    super.init(egiApp, userGroup);

    const navigationItems = egiApp.rootNavigationItem.asArray;

    const authorizedFeatureNavigationItemKeys = navigationItems
      .map(item => {
        return item.regularFeatures
          .filter(f => this.userGroup.hasAccessTo(item, f.featureId))
          .map(f => this.concatIds(f, item));
      })
      .flat();

    this.selectionForm.init(...authorizedFeatureNavigationItemKeys);
  }

  getChanges(): ChangedItem<NavigationItemFeatureChange>[] {
    return this.allNavigationItems
      .map(item => {
        return item.regularFeatures
          .filter(f => this.selectionForm.hasChanged(this.concatIds(f, item)))
          .map(feature => {
            const key = this.concatIds(feature, item);
            const changeType = this.selectionForm.decideSelectionChangeType(key);

            return {
              item: {
                feature,
                navigationItem: item
              },
              type: changeType
            };
          });
      })
      .flat(2);
  }

  select(feature: PageFeature, navigationItem: NavigationItemEntity): void {
    const key = this.concatIds(feature, navigationItem);
    this.selectionForm.select(key);
  }

  deselect(f: PageFeature, navigationItem: NavigationItemEntity): void {
    this.selectionForm.deselect(this.concatIds(f, navigationItem));
  }

  selectAll(): void {
    this.allNavigationItems.forEach(item => {
      return item.regularFeatures.forEach(f => {
        this.selectionForm.select(this.concatIds(f, item));
      });
    });
  }

  toggle(f: PageFeature, i: NavigationItemEntity): boolean {
    this.selectionForm.toggle(this.concatIds(f, i));
    return this.isSelected(f, i);
  }

  isSelected(f: PageFeature, i: NavigationItemEntity): boolean {
    return this.selectionForm.isSelected(this.concatIds(f, i));
  }

  private concatIds({ featureId }: PageFeature, { id }: NavigationItemEntity): string {
    return featureId + id;
  }

  get allNavigationItems(): NavigationItemEntity[] {
    return this.egiApp.rootNavigationItem.asArray;
  }
}

export interface NavigationItemFeatureChange {
  feature: PageFeature;
  navigationItem: NavigationItemEntity;
}
